export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref10792.c7206834.jpg";